import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerServiceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Mobile PWA Batch B2 — installable static app shell. Safe on desktop
// (browsers just ignore it when the viewport / display-mode isn't PWA).
registerServiceWorker();
